import CryptoJS from 'crypto-js'

/**
 * 生成随机字符串 (rd)
 */
export function generateRd(): string {
  return Math.random().toString(36).slice(2, 10)
}

/**
 * 获取当前秒级时间戳
 */
export function getTimestamp(): string {
  return Math.floor(Date.now() / 1000).toString()
}

/**
 * 生成签名 Prefix (取 HMAC 的前16位)
 */
export function getSignaturePrefix(message: string, key: string): string {
  const hmac = CryptoJS.HmacSHA256(message, key)
  const signature = CryptoJS.enc.Hex.stringify(hmac)
  return signature.slice(0, 16)
}

export function isValidOrigin(urlString: string | undefined) {
  if (!urlString) {
    return false
  }

  // 允许的域名列表
  const domainPattern = `(?:oray\.com|oraybeta\.com|hskcloud\.com|ewei\.net|aweray\.com|aweraybeta\.com|pgybox\.com|pgybox\.net)`
  const regex = new RegExp(`^(?:^|.*?\\.)${domainPattern}$`, 'i')

  let processedUrlString = urlString.trim()

  if (!processedUrlString.includes('://')) {
    processedUrlString = 'http://' + processedUrlString
  }

  try {
    const hostname = new URL(processedUrlString).hostname
    return regex.test(hostname)
  } catch (e) {
    return false
  }
}

/**
 * 判断是否为移动端
 */
export function isMobile(): boolean {
  if (typeof navigator === 'undefined') return false
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
}
